<template>
    <div class="inputEdit">
        <p class="remind">请确认与原件信息是否一致，如有不符可手动修改：</p>
        <!--身份证正面编辑-->
        <el-form ref="idcardForm" :model="editData" label-width="150px" class="idcardForm" v-if="chooseType">
            <el-form-item :label="this.$store.state.stepNum == 2 ? editLabel.idcardFront.name.zh : editLabel.idcardFront.name.en">
                <el-input v-model="editData.name.words"></el-input>
            </el-form-item>
            <el-form-item :label="this.$store.state.stepNum == 2 ? editLabel.idcardFront.gender.zh : editLabel.idcardFront.gender.en" class="inlineLabel">
                <el-input v-model="editData.gender.words" class="inlineInput"></el-input>
            </el-form-item>
            <el-form-item :label="this.$store.state.stepNum == 2 ? editLabel.idcardFront.ethnicity.zh : editLabel.idcardFront.ethnicity.en" class="inlineLabel">
                <el-input v-model="editData.nationality.words" class="inlineInput"></el-input>
            </el-form-item>
            <el-form-item :label="this.$store.state.stepNum == 2 ? editLabel.idcardFront.dateOfBirth.zh : editLabel.idcardFront.dateOfBirth.en">
                <el-input v-model="editData.born.words" v-if="this.$store.state.stepNum == 3"></el-input>
                <el-date-picker v-if="this.$store.state.stepNum == 2"
                                v-model="editData.born.words"
                                type="date"
                                format="yyyy 年 MM 月 dd 日"
                                value-format="yyyyMMdd">
                </el-date-picker>
            </el-form-item>
            <el-form-item :label="this.$store.state.stepNum == 2 ? editLabel.idcardFront.address.zh : editLabel.idcardFront.address.en">
                <el-input v-model="editData.address.words" type="textarea"></el-input>
            </el-form-item>
            <el-form-item :label="this.$store.state.stepNum == 2 ? editLabel.idcardFront.idnumber.zh : editLabel.idcardFront.idnumber.en">
                <el-input v-model="editData.id_card_number.words"></el-input>
            </el-form-item>
        </el-form>

        <!--身份证反面编辑-->
        <el-form ref="idcardReverse" :model="editData" label-width="150px" class="idcardForm" v-if="!chooseType">
            <el-input v-model="this.$store.state.stepNum == 2 ? editLabel.idcardBack.first.zh : editLabel.idcardBack.first.en" class="nolabelIpt" disabled></el-input>
            <el-input v-model="this.$store.state.stepNum == 2 ? editLabel.idcardBack.second.zh : editLabel.idcardBack.second.en" class="nolabelIpt" disabled></el-input>
            <el-form-item :label="this.$store.state.stepNum == 2 ? editLabel.idcardBack.issueOrganization.zh : editLabel.idcardBack.issueOrganization.en">
                <el-input v-model="editData.issue_organization.words"></el-input>
            </el-form-item>
            <el-form-item :label="this.$store.state.stepNum == 2 ? editLabel.idcardBack.issueDate.zh : editLabel.idcardBack.issueDate.en" class="datepicker">
                <el-date-picker v-if="this.$store.state.stepNum == 2"
                                v-model="editData.issue_date.words"
                                type="date"
                                format="yyyy 年 MM 月 dd 日"
                                value-format="yyyyMMdd">
                </el-date-picker>
                <span class="dateTxt" v-if="this.$store.state.stepNum == 2">——</span>
                <el-input v-model="editData.expiration_date.words" v-if="this.$store.state.stepNum == 3"></el-input>
                <el-date-picker v-if="this.$store.state.stepNum == 2"
                                v-model="editData.expiration_date.words"
                                type="date" :picker-options="rulesOption"
                                format="yyyy 年 MM 月 dd 日"
                                value-format="yyyyMMdd">
                </el-date-picker>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import editLabel from "../i18nJSON";
    export default {
        name:"inputEdit",
        props:["chooseType","editData"],
        data(){
            return{
                editLabel:editLabel,
                rulesOption:{
                    disabledDate:time=>{
                        let delay = this.editData.issue_date.words;
                        var dateStr = delay.slice(0,4)+"-"+delay.slice(4,6)+"-"+delay.slice(6);
                        if(delay){
                            return time.getTime() < new Date(dateStr).getTime();
                        }
                    }
                }
            }
        },
        watch:{
            editData: {
                handler(newValue, olgValue) {
                    // 变化的时候保存起来
                    if(this.$store.state.stepNum == 3){
                        var timer;
                        var self = this;
                        if(timer){
                            window.clearTimeout(timer);
                        }
                        timer = window.setTimeout(()=>{
                            localStorage.setItem(`idcardEnData${self.$route.query.id}`, JSON.stringify(newValue));
                        }, 1000)
                    }
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style>
    .remind{
        color: #d82a22;
        margin-left: 50px;
        line-height: 100px;
    }
    .idcardForm{
        border: solid 1px #eee;
        width: 80%;
        margin: 30px 5%;
        padding: 30px 50px;
    }
    .inlineLabel{
        display: inline-block;
        margin-right: 30px;
    }
    .inlineInput{
        width:130%;
    }
    .inlineIpt{
        width: 200px;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width: 100%;
    }
    .nolabelIpt{
        margin-bottom: 20px;
    }
    .nolabelIpt input{
        text-align: center;
    }
    .datepicker .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width: 43% !important;
    }
    .datepicker .dateTxt{
        margin: 0 3%;
    }
</style>
